import { Language } from '@yleisradio/areena-types';
import { Notification, notifications } from '../Notifications/types';

const time = 1000;

export const selectedConsentAcceptedNotification = (
  language: Language
): Notification => {
  return {
    id: 'selectedConsentAcceptedNotification',
    message:
      language === 'sv'
        ? `Valda cookies godkända`
        : `Valitut evästeet hyväksytty`,
    hideAutomatically: true,
    time,
    messageType: notifications.SUCCESS,
  };
};

export const allConsentAcceptedNotification = (
  language: Language
): Notification => {
  return {
    id: 'allConsentAcceptedNotification',
    message:
      language === 'sv'
        ? `Alla cookies godkända`
        : `Kaikki evästeet hyväksytty`,
    hideAutomatically: true,
    time,
    messageType: notifications.SUCCESS,
  };
};
